<template>
    <modal dialog="modal-x-small" class="add-event-modal fluid">
        <div slot="title">New Product</div>

        <div slot="body">
            <div class="selections wrapper">
                <vue-select label="name" placeholder="- Select product -" v-model="newEventProduct" :value="newEvent.product.id" :options="products"></vue-select>
                <vue-select label="name" placeholder="- Select vehicle -" v-model="newEventVehicle" :value="newEvent.product.transport.id" :options="transports"></vue-select>
            </div>

            <div class="timestamps border-top-light border-bottom-light bold" v-if="start && end">
                <div class="d-flex wrapper">
                    <div class="flex-all">
                        <label>Date</label>
                        <p>
                            <span>{{ formatDate(start) }}</span>

                            <span v-if="!start.isSame(end, 'day')">
                                to {{ formatDate(end) }}
                            </span>
                        </p>
                    </div>
                    <div class="flex-all">
                        <label>Time</label>
                        <p>
                            {{ start.format('HH:mm:ss') }} - {{ end.format('HH:mm:ss') }}
                        </p>
                    </div>
                </div>
            </div>

            <div class="timestamps border-top-light border-bottom-light" v-else>
                <div class="d-flex wrapper">
                    <div>
                        <label>Starts</label>
                        <vue-datepicker
                            :value="newEventStartDate"
                            v-on:selected="setEventStartDate"
                            wrapper-class="date-input"
                            :monday-first="false"
                            :required="true">
                        </vue-datepicker>
                    </div>

                    <div>
                        <label>Time</label>
                        <timepicker @change="setEventStartTime" :defaultTime="newEventStartTime"></timepicker>
                    </div>
                </div>

                <div class="d-flex wrapper">
                    <div>
                        <label>Ends</label>
                        <vue-datepicker
                            :value="newEventEndDate"
                            v-on:selected="setEventEndDate"
                            wrapper-class="date-input"
                            :monday-first="false"
                            :required="true">
                        </vue-datepicker>
                    </div>
                    <div>
                        <label>Time</label>
                        <timepicker @change="setEventEndTime" :defaultTime="newEventEndTime"></timepicker>
                    </div>
                </div>
            </div>

            <div class="wrapper">
                <vue-select label="name" placeholder="- Select location -" v-model="newEventLocation" :value="newEvent.product.location.id" :options="locations"></vue-select>

                <label class="mt-3">Availability limit</label>
                <div class="d-flex">
                    <!-- <input v-model="spotsTotal" :value="spotsTotal" type="text" placeholder="Add capacity"> -->
                    <input v-model="spotsTotal" type="text" placeholder="Add capacity">
                    <div class="ml-5">
                        <label class="mt-2">
                            <checkbox @input="setAllotment">
                                Set allotment
                            </checkbox>
                        </label>
                    </div>
                </div>

            </div>

            <div v-if="allotment" class="allotment border-top-light mt-2 pt-3 wrapper">
                <div class="form-group row">
                    <div class="col-sm-6">
                        <label>Allotment limit</label>
                        <!-- <input v-model="spotsAllotted" :value="spotsAllotted" type="text" placeholder="Add allotment"> -->
                        <input v-model="spotsAllotted" type="text" placeholder="Add allotment">
                    </div>
                    <div class="col-sm-6">
                        <label>Linked to</label>
                        <vue-select
                                class=""
                                v-model="selectedLink"
                                :value="newEvent.linked"
                                :options="links">
                        </vue-select>
                    </div>
                </div>
            </div>
        </div>

        <div slot="footer" class="d-flex flex-all">
            <button type="button" class="btn yes wide flex-all" @click="save" :disabled="isSaving">Save</button>
        </div>
    </modal>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import Modal from './Modal'
    import Timepicker from '../Timepicker'
    import VueSelect from 'vue-select'
    import VueDatepicker from 'vuejs-datepicker'

    export default {
        data: function() {
            return initialState();
        },
        computed: {
            locations: function() {
                let locations = [];

                this.events.forEach(event => {
                    if (event.product !== undefined && event.product.location !== undefined) {
                        locations.push(event.product.location);
                    }
                });

                return locations;
            },
            products: function() {
                let products = [];

                this.events.forEach(event => {
                    if (event.product !== undefined) {
                        products.push(event.product);
                    }
                });

                return products;
            },
            transports: function() {
                let transports = [];

                this.events.forEach(event => {
                    if (event.product !== undefined && event.product.transport !== undefined) {
                        transports.push(event.product.transport);
                    }
                });

                return transports;
            },
        },
        methods: {
            ...mapActions([
                'pushEvent',
                'closeModal'
            ]),
            save: function() {
                this.addEvent();
                this.closeModal();
            },
            addEvent: function() {
                // Set dates: if start and end dates have been set, we're adding from
                // the calendar, otherwise we'll be setting them manually
                this.isSaving = true;
                this.newEvent = {
                    start: (this.start ? this.start : moment(this.newEventStartDate)),
                    end: (this.end ? this.end : moment(this.newEventEndDate)),
                    completed: 0,
                    vehicle_id: this.newEventVehicle.id,
                    product_id: this.newEventProduct.id,
                    location_id: this.newEventLocation.id,
                    spots: {
                        total: this.spotsTotal || 0,
                        taken: 0,
                        allotted: this.spotsAllotted || 0,
                    }
                }

                // Add the event

                this.pushEvent(this.newEvent);

                // Refresh calendar

                $('#calendar').fullCalendar('renderEvent', this.newEvent, true);
                this.isSaving = false;
            },
            setEventStartDate: function(date) {
                this.newEventStartDate = date;
                this.newEventStartDate.setHours(this.newEventStartTime[0], this.newEventStartTime[1], 0, 0);
            },
            setEventEndDate: function(date) {
                this.newEventEndDate = date;
                this.newEventEndDate.setHours(this.newEventEndTime[0], this.newEventEndTime[1], 0, 0);
            },
            setEventStartTime: function(t) {
                this.newEventStartTime = t.split(':');
                this.newEventStartDate.setHours(this.newEventStartTime[0], this.newEventStartTime[1], 0, 0);
            },
            setEventEndTime: function(t) {
                this.newEventEndTime = t.split(':');
                this.newEventEndDate.setHours(this.newEventEndTime[0], this.newEventEndTime[1], 0, 0);
            },
            resetWindow: function() {
                Object.assign(this.$data, initialState());
            },
            setAllotment: function(e) {
                this.allotment = !this.allotment;
            },
        },
        components: {
            Modal,
            Timepicker,
            VueSelect,
            VueDatepicker,
        }
    }

    function initialState() {
        // Initialize start and end date as "now" +1 and +2 hours respectively

        var startDate = new Date();
        var endDate = new Date();
        var startTime = ['09', '00'];
        var endTime = ['10', '00'];

        startDate.setHours(startTime[0], startTime[1], 0, 0);
        endDate.setHours(endTime[0], endTime[1], 0, 0);

        return {
            allotment: false,
            links: ['AlgarExperience'],
            selectedLink: 'AlgarExperience',
            newEvent: {
                spots: {
                    total: 0,
                    taken: 0,
                    allotted: 0,
                }
            },
            newEventVehicle: null,
            newEventLocation: null,
            newEventProduct: null,
            newEventStartDate: startDate,
            newEventEndDate: endDate,
            newEventStartTime: startTime,
            newEventEndTime: endTime,
            spotsTotal: 0,
            spotsAllotted: 0,
            isSaving: false
        }
    }
</script>

<style lang="scss">
    @import '../../assets/scss/_variables.scss';

    .add-event-modal {
        .selections .v-select {
            margin: 0 0 1rem;
        }

        .timestamps {
            padding: 0.5rem 0;
            margin: 1rem 0;

            > .wrapper > div {
                flex: 1 1 0;
            }
        }

        .date-input {
            margin-right: 1rem;
        }
    }
</style>



// WEBPACK FOOTER //
// EventAdd.vue?7c0ee008